module.exports = __webpack_public_path__ + "img/back03.0ce2e9a4.jpg";